<div class="container">
    <div class="row">
        <div class="col-xs-12 candidate-job-match-card-report-label">
            <span *ngIf="!loadingFlag">
                <span>{{reportTitle}}</span> of '<span class="emerald">{{jobMatch.name}}</span>' for the role of '<span class="emerald">{{jobMatch.jobMatchTitle}}</span>'
                 <span *ngIf="jobMatch.jobMatchClientName">at '<span class="emerald">{{jobMatch.jobMatchClientName}}</span>'</span>
            </span>
        </div>
    </div>
    <div class="row" *ngIf="reportLoadingFlag || loadingFlag">
        <div class="col-xs-12">
            <div class="skeleton-heading skeleton-loading" style="width: 35%; margin-bottom: 14px;"></div>
            <div *ngFor="let row of [0, 1, 2]" style="margin-bottom: 16px;">
                <div class="skeleton-paragraph skeleton-loading" style="width: 20%; margin-bottom: 8px;"></div>
                <div class="skeleton-loading" style="height: 34px; width: 100%;"></div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!reportLoadingFlag">
        <div class="col-xs-12" *ngIf="!reportGenerating && !reportError">
            <object [data]="embedUrl" type="application/pdf" style="width:100%; height:500px;">
                <embed [src]="url" type="application/pdf" width="100%" height="500px" />
            </object>
        </div>
        <div class="col-xs-12 text-center" *ngIf="reportGenerating">
            <div class="report-generating flex flex-column align-items-center justify-content-center">
                <div>
                    <span style="font-size: 30px;" class="fa fa-exclamation-triangle text-warning"></span>
                </div>
                <div class="mt-2">
                    <p>The report is currently being generated. Please try again after some time.</p>
                </div>
            </div>
        </div>
        <div class="col-xs-12 text-center" *ngIf="reportError">
            <div class="report-generating flex flex-column align-items-center justify-content-center">
                <div>
                    <span style="font-size: 30px;" class="fa fa-exclamation-circle text-danger"></span>
                </div>
                <div class="mt-2">
                    <p>Something went wrong while loading the report. Please try again later.</p>
                </div>
            </div>
        </div>
    </div>
</div>